<div class="mat-form-field-flex flex-column page-container">
  <ng-container *ngIf="!isLoadingTile">

    <div class="d-flex flex-row justify-content-end align-items-center w-100">
      <button class="blue-border note-button me-3"
              (click)="openPrivateNoteDialog()"
              [class]="(privateNote$|async)?.note ? 'active' : ''"
              matTooltip="{{'proposalDetails.privateNote' | translate}}"
              [matTooltipShowDelay]="1000">
        <img class="icon" alt="" [src]="(privateNote$|async)?.note ? 'assets/svg-icons/comment-active.svg' : 'assets/svg-icons/comment.svg'">
      </button>
      <button (click)="downloadPdf()" class="blue-border download-button"
          matTooltip="{{'proposalDetails.slipDownload' | translate}}"
          [matTooltipShowDelay]="1000">
        <img class="icon" alt="{{'proposalDetails.slipDownload' | translate}}" src="assets/svg-icons/download-new.svg">
      </button>
    </div>
  </ng-container>

  <div class="proposal-slip-container position-relative">
    <iframe *ngIf="showPdf" id="proposalSlip" title="{{'proposalSlip.title' | translate}}" width="100%" height="1250"></iframe>
  </div>

</div>
